export const testId = {
    addSticker: "add-sticker",
    stickerPopoverRoot: "sticker-popover-root",
    stickerPopoverContainer: "sticker-popover-container",
    stickerPopoverEmptyMessage: "sticker-popover-empty-message",
    stickerPopoverLoadingMessage: "sticker-popover-loading-message",
    stickerPopoverErrorMessage: "sticker-popover-error-message",
    stickerPopoverErrorRefresh: "sticker-popover-error-refresh"
} as const
